export default {
  units: [],
  profiles: [],
  users: [],
  permissaoUni: [],
  permissaoServ: [],
  userListDownload: 0
}
